import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, setSeo } from "@/lib/api";
import ProductGrid from "@/components/ProductGrid";

const HERO = "https://images.unsplash.com/photo-1736240624842-c13db7ba4275?crop=entropy&cs=srgb&fm=jpg&q=90&w=1600";

export default function HajjUmrah() {
  useEffect(() => setSeo("Hajj & Umrah Essentials | Ihram-Friendly Abayas | Adam's", "Shop ihram-friendly abayas, travel hijab sets & prayer essentials for Hajj & Umrah at Adam's The Islamic Boutique."), []);
  const { data = [], isLoading } = useQuery({ queryKey: ["hajj"], queryFn: async () => (await api.get("/products?category=hajj-umrah")).data });

  return (
    <div>
      <section className="relative h-[50vh] min-h-[380px] overflow-hidden">
        <img src={HERO} alt="Hajj and Umrah" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-espresso/65" />
        <div className="relative h-full flex items-center justify-center text-center px-6">
          <div>
            <p className="text-champagne-light overline mb-3">Sacred Journeys</p>
            <h1 className="font-serif text-5xl lg:text-6xl text-ivory">Hajj & Umrah Essentials</h1>
            <p className="text-ivory/80 mt-4 max-w-xl mx-auto font-sans">Thoughtfully curated with comfort, modesty and grace for your sacred journey.</p>
          </div>
        </div>
      </section>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-12 lg:py-16">
        <ProductGrid products={data} loading={isLoading} cols={4} paginate pageSize={12} />
      </div>
    </div>
  );
}
